import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { BuildVersion } from 'src/environments/environment-model.interface';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  standalone: true,
})
export class PrivacyPolicyComponent {
  public readonly environment = environment;
  public readonly buildVersion = BuildVersion;
  public readonly isIos = this._platform.is('ios');
  public readonly isAndroid = this._platform.is('android');

  constructor(private _platform: Platform) {}
}
